import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild, forwardRef, Inject } from '@angular/core';

import {
  ControlContainer,
  NgForm,
  NgModel
} from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { BigDecimalService }    from '../../../core/services/big-decimal.service';
import { SessionService }       from '../../../sessions/session.service';
import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector       : 'wor-number-control',
  template: require('./number-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class NumberControlComponent extends TextControlComponent {
  public currencySymbol = this.sessionService.currency().symbol;

  @Input() isCurrency   = false;
  @Input() isPercentage = false;
  @Input() max         ?: number;
  @Input() min          = 0;
  @Input() round        = 2;

  @Input() set model ( _model : any ) {
    if ( this.control && this.control.valid ) {
      this._model = this.roundModel(_model);
    }
    else {
      this._model = _model;
    }
  };

  @ViewChild('input') control : NgModel;

  constructor (
    @Inject(forwardRef(() => BigDecimalService))
    private bigDecimalService: BigDecimalService,
    @Inject(forwardRef(() => SessionService))
    private sessionService   : SessionService,
    private translateService : TranslateService
  ) {
    super();
  }

  getLabel ( control : NgModel ) : string {
    if ( control.errors?.min ) {
      return this.translateService.instant('VALIDATIONS.NUMBER.TOO_SMALL', {
        min: this.min
      });
    }

    if ( control.errors?.max ) {
      return this.translateService.instant('VALIDATIONS.NUMBER.TOO_BIG', {
        max: this.max
      });
    }

    if ( control.errors?.number ) {
      return this.translateService.instant('VALIDATIONS.NUMBER.INVALID');
    }

    return this.label;
  }

  handleModelChange ( _model : string ) : void {
    if ( this.control && this.control.value && this.control.valid ) {
      this.model = this.roundModel(_model);

      this.modelChange.emit(this.model);
    }

  }

  roundModel ( model : string ) : string {
    const unscaledValue = this.bigDecimalService.get(model);

    return ( unscaledValue.scale() > this.round )
      ? this.bigDecimalService.get(model, this.round).toString()
      : model;
  }
}
